import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = s((i, o) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: o,
    ...i,
    image: (e) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69110)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 15a1 1 0 0 1-.768-.36l-3.72-4.463A6.52 6.52 0 0 1 2 6a6 6 0 1 1 12 0 6.52 6.52 0 0 1-1.512 4.177l-3.72 4.463A1 1 0 0 1 8 15m0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69110", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M16 16H0V0h16z" }) }) })
        ]
      }
    )
  }
));
t.displayName = "LocationIcon";
export {
  t as LocationIcon,
  t as default
};
//# sourceMappingURL=index.js.map
